export type Plan = 'free' | 'pro';

export interface PlanLimits {
  syncedDevices: number;
  /** Days the full captured text is retained in the cloud. Infinity = unlimited. */
  cloudContentRetentionDays: number;
  semanticSearch: boolean;
  aiCollections: boolean;
  autoCloseDuplicates: boolean;
}

/**
 * Local capture and local search are unlimited on every plan — that is the
 * trust wedge against capacity-capped competitors (Toby's 60-item free cap).
 * Cloud convenience is what Pro sells. (docs/DECISIONS.md #2)
 */
export const PLANS: Record<Plan, PlanLimits> = {
  free: {
    syncedDevices: 1,
    cloudContentRetentionDays: 30,
    semanticSearch: false,
    aiCollections: false,
    autoCloseDuplicates: false,
  },
  pro: {
    syncedDevices: Number.POSITIVE_INFINITY,
    cloudContentRetentionDays: Number.POSITIVE_INFINITY,
    semanticSearch: true,
    aiCollections: true,
    autoCloseDuplicates: true,
  },
};

export const PRICING = {
  pro: { monthlyUsd: 4, yearlyUsd: 36 },
} as const;
